import React from 'react';
import PropTypes from 'prop-types';

import { DateService, get, IntlManager, useApplicationState } from '@atlas/core';
import { Label } from '@atlas/ui';

import { millisecondsInDay } from 'common/constants';
import useTranslate from 'common/I18n/Interpreter';

const FreeBetsTableItemExpanded = ({ freeBet }) => {
  const t = useTranslate();

  const applicationState = useApplicationState();
  const currency = get(applicationState, 'wallet.currency');

  const { freeBet: { description, endTime, freeBetAmounts, startTime, timeToUse } = {} } = freeBet;

  const freeBetAmount = IntlManager.formatMoney(freeBetAmounts[currency] || 0);

  const daysToUse = Math.round(timeToUse / millisecondsInDay);

  const startBonusTime = DateService.getFormattedDate(startTime);
  const endBonusTime = DateService.getFormattedDate(endTime);

  return (
    <div className="bonus-info-expanded">
      <div className="bonus-info-expanded-info">
        <div>
          <Label className="sub-title-text" message="freebet_amount" />
          <span className="title-small-text">{freeBetAmount}</span>
        </div>
        <div>
          <Label className="sub-title-text" message="freebet_period_for_using" />
          <span className="title-small-text">
            {daysToUse} {t('days')}
          </span>
        </div>
        <div>
          <span className="sub-title-text">
            {t('bonus_start_date')} - {t('bonus_end_date')}:
          </span>
          <span className="title-small-text">
            {startBonusTime} - {endBonusTime}
          </span>
        </div>
      </div>
      {description && <div className="bonus-description title-small-300-text">{description}</div>}
    </div>
  );
};

FreeBetsTableItemExpanded.propTypes = { freeBet: PropTypes.object.isRequired };

export default FreeBetsTableItemExpanded;
